import { render } from "./CoinsSwapIcon.vue?vue&type=template&id=0d9d1e5c"
import script from "./CoinsSwapIcon.vue?vue&type=script&lang=js"
export * from "./CoinsSwapIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__